import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Shared admin page chrome so every workspace page reads the same way as the
 * Dashboard and Tasks & approvals pages.
 */
export const AdminPageHeader = ({ eyebrow, title, subtitle, actions }) => (
  <div className="flex items-start justify-between gap-4">
    <div className="min-w-0">
      {eyebrow && (
        <p className="text-[10px] uppercase tracking-[0.14em] text-foreground-muted">{eyebrow}</p>
      )}
      <h1 className="text-xl md:text-2xl font-heading mt-1 truncate">{title}</h1>
      {subtitle && <p className="text-sm text-foreground-muted mt-0.5">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
  </div>
);

export const AdminKpi = ({ label, value, tone, testId }) => (
  <div className="px-4 py-3 md:px-5 md:py-4 min-w-[140px]" data-testid={testId}>
    <p className="text-[10px] uppercase tracking-[0.14em] text-foreground-muted">{label}</p>
    <p className={cn('text-lg md:text-xl font-semibold text-slate-900 mt-1 tabular-nums', tone)}>{value}</p>
  </div>
);

export const AdminKpiStrip = ({ children, className }) => (
  <div
    className={cn(
      'bg-white rounded-xl border border-black/[0.06] flex overflow-x-auto divide-x divide-black/[0.05]',
      className
    )}
    data-testid="admin-kpi-strip"
  >
    {children}
  </div>
);

export default AdminPageHeader;
